import { render, staticRenderFns } from "./year-revision.vue?vue&type=template&id=3e2da80c&scoped=true"
import script from "./year-revision.vue?vue&type=script&lang=js"
export * from "./year-revision.vue?vue&type=script&lang=js"
import style0 from "./year-revision.vue?vue&type=style&index=0&id=3e2da80c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e2da80c",
  null
  
)

export default component.exports